module.exports = __webpack_public_path__ + "img/Debbas.8f7a0a86.jpg";